import { IkasProductAttribute } from ".";
import { IkasProductAttributeTranslation } from "./translation";

export function initIkasProductAttribute(
  attribute: IkasProductAttribute,
  locale: string | null
) {
  if (attribute.translations && locale) {
    setTranslations(attribute, attribute.translations, locale);
    delete attribute.translations;
  }
}

function setTranslations(
  attribute: IkasProductAttribute,
  translations: IkasProductAttributeTranslation[],
  locale: string
) {
  if (translations && translations.some((t) => t.locale === locale)) {
    const localeTranslations = translations.find((t) => t.locale === locale);

    if (localeTranslations?.name) attribute.name = localeTranslations.name;
    if (localeTranslations?.description)
      attribute.description = localeTranslations.description;
    if (localeTranslations?.options) {
      attribute.options?.forEach((o) => {
        const translatedVV = localeTranslations.options?.find(
          (to) => to.id === o.id
        );
        if (translatedVV && translatedVV.name) o.name = translatedVV.name;
      });
    }
  }
}
